/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';

// ========= module component import section ========= //
import { Modal } from 'reactstrap';
import { IconContext } from 'react-icons';
import { GrClose } from 'react-icons/gr';
import { BsArrowRight } from 'react-icons/bs';
import _ from 'lodash';
// ====== end of module component import section ====== //

// ========= project component import section ========= //
import { emptyImage, getCloudImageUrl, WAREHOUSE, _NEW } from '../../../utils';
import {
  accessoriesCondition,
  boxCondition,
  boxHandbag,
  dustBag,
  handbagCondition,
  sneakersCondition,
  yellowing,
  displayItem,
  sneakersDefect,
  sneakerDefectsCondition
} from '../../../utils/Helpers';
// ====== end of project component import section ====== //

// ========= action import section ========= //
import { doAcceptOfferRequest } from '../../../actions/offerAction';
// ====== end of action import section ====== //

// ========= interface import section ========= //
import DataOfferInterface, {
  MaxAmountStateInterface,
} from '../../../interface/reducers/offer';
import DataPostalCodeInterface, {
  CourierStateInterface,
} from '../../../interface/reducers/postalCode';
import AuthInterface from '../../../interface/reducers/auth';
import DataHistoryInterface, {
  DataPenjualanInterface,
} from '../../../interface/reducers/history';
import { handleSuspended } from '../../../actions/saleActions';
import { getStatusProcessRiwayat } from '../SellingTabs/InProgress';
// ====== end of interface import section ====== //

type PayloadAcceptOffer = {
  bid_id: number;
};

type PayloadDeleteListing = {
  status: string;
};

type PayloadChangePrice = {
  status: string;
  asking_price: number;
};

type stateToProps = {
  dataOffer: DataOfferInterface;
  dataPostalCode: DataPostalCodeInterface;
  dataAuth: AuthInterface;
  dataHistory: DataHistoryInterface;
};

interface ModalInProgress extends stateToProps {
  isOpen: boolean;
  ratio: number;
  couriers: CourierStateInterface;
  maxAmount: MaxAmountStateInterface;
  currency: string;
  data: DataPenjualanInterface;
  onToggle: () => any;
  toggleAWB: () => any;
  callbackAfterUpdate?: (...args: any) => any;
  doAcceptOffer: (query: number, payload: PayloadAcceptOffer) => Promise<any>;
  doDeleteListing: (
    idSale: number,
    status: PayloadDeleteListing,
  ) => Promise<any>;
  doChangePrice: (idSale: number, body: PayloadChangePrice) => Promise<any>;
}

/**
 * Modal for Selling Current Detail on User Dashboard section for Kick Avenue 3.0 Website.
 * Author: Rifqy Zacky Ariadhy (rifqyzackya@gmail.com)
 * ===============================================
 * @param {ModalInProgress} props for this component.
 * @return {JSX.Element}
 */
function ModalInProgressSellingComponent({
  isOpen,
  onToggle,
  ratio,
  currency,
  toggleAWB,
  data,
  confirmationText
}: ModalInProgress): JSX.Element {
  // If data is available, then show the modal
  if (data.hasOwnProperty('id')) {
    const isDefects = data?.user_sell?.defects?.length > 0
    const imageUrl = data.sale[0]?.sale_product?.product_variant
      ?.product_variant_images?.length
      ? data.sale[0]?.sale_product?.product_variant?.product_variant_images[0]
        .URL
      : null;
    const category =
      data.sale[0]?.sale_product?.category_name;
    const uniqueDefects = _.uniqBy(
      isDefects ? data.user_sell.defects : null,
      'name',
    );
    const dustBagCondition = uniqueDefects
      ? uniqueDefects.find((a) => a.name === 'DUST_BAG' && a.value)
      : {};
    const boxConditions = uniqueDefects
      ? uniqueDefects.find((a) => a.name === 'BOX')
      : {};
    const hideBoxInfo = data.user_sell.product_variant.hide_box_info;
    const isVintage = data.sale[0]?.sale_product?.product_variant?.vintage;
    const sneakersDetailArr = [
      isVintage ? "Vintage" : sneakersCondition(data.user_sell.sneakers_condition),
      hideBoxInfo ? '' : boxCondition(data.user_sell.box_condition),
      accessoriesCondition(data.user_sell.missing_accessories),
      yellowing(data.user_sell.yellowing),
      displayItem(data.user_sell.display_item),
      sneakersDefect(data.user_sell.sneakers_defect),
      isDefects ? sneakerDefectsCondition(uniqueDefects) : '',
    ];
    const sneakersDetail = sneakersDetailArr
      .filter((item) => item !== '')
      .map((items) => items)
      .join(' / ');

    const isSelectMethod = (item) => {
      const { status = "" } = item.shipper || {}
      if (!status) return true;

      return false;
    }
    const isSelectScheduled = (item) => {
      const { status = "" } = item.shipper || {}
      if (status === "NEW") return true;

      return false;
    }
    const isSelectCour =
      data.sale[0].status === _NEW[0] &&
      data.sale[0].seller_responded !== null &&
      (isSelectMethod(data.sale[0]) || isSelectScheduled(data.sale[0]))

    const txtStatus = getStatusProcessRiwayat(data?.sale[0]);

    const LuxuryArr = [
      sneakersCondition(data.user_sell.sneakers_condition),
      accessoriesCondition(data.user_sell.missing_accessories),
      dustBag(dustBagCondition),
      boxConditions?.value ? null : boxHandbag(boxConditions),
      isDefects ? handbagCondition(uniqueDefects) : ""
    ];

    const LuxuryDetails = LuxuryArr.filter((item) => item !== '' && item !== null)
      .map((items) => items)
      .join(' / ');

    const isTicket = data?.sale[0]?.sale_product?.product_variant?.product?.name.includes('Ticket');

    return (
      <Modal
        className="offer-detail-modal"
        toggle={onToggle}
        isOpen={isOpen}
        centered
      >
        <>
          <div className={'content-modal'}>
            <div className={'header-section'}>
              <div className={'left'}>
                <p className={'product-title'}>
                  {data.sale[0]?.sale_product?.product_variant?.display_name}
                </p>
                <p className={'product-sku'}>
                  {data.sale[0]?.sale_product?.product_variant?.SKU}
                </p>
              </div>
              <div className={'right'}>
                <div>
                  {category === 'handbags' ||
                    (category === 'lifestyles' &&
                      data.sale?.[0]?.sale_product?.size?.US.toLowerCase() !==
                      'all size') ? (
                    <div className={'size-container'}>
                      <p>{data.sale?.[0]?.sale_product?.size?.US}</p>
                    </div>
                  ) : (
                    <div className={'size-container'}>
                      <p>US {data.sale?.[0]?.sale_product?.size?.US}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className={'image-section'}>
              <KickImage
                src={
                  imageUrl
                    ? getCloudImageUrl(imageUrl, 300)
                    : emptyImage(category)
                }
              />
            </div>
            <div
              className={`status-section ${isSelectCour ? 'orange' : 'green'}`}
            >
              <p>
                {txtStatus === 'Waiting for sales confirmation'
                  ? 'Order Received'
                  : txtStatus}
              </p>
            </div>
            <div className={'grey-box-section'}>
              <div className={'container-row'}>
                <div className={'item'}>
                  <p className={'title'}>Order ID</p>
                  <p className={'value'}>{data.invoice_number || '-'}</p>
                </div>
              </div>
              <div className={'container no-mb'}>
                <p className={'title'}>Product Conditions</p>
                {
                  isTicket ?
                  <p className={'value'}>{sneakersCondition(data.user_sell.sneakers_condition)}</p> :
                  <p className={'value'}>
                    {category === 'handbags'
                      ? LuxuryDetails
                      : sneakersDetail}
                  </p>
                }
              </div>
            </div>
            <div className={'info-section'}>
              <p>
                Please consistently check yout emails and notifications to
                receive any information regarding your package
              </p>
            </div>
            <div className={`info-section confirmation-text`}>
              <p>{confirmationText}</p>
            </div>
            {isSelectCour && (
              <div className={'bottom-button-section selling-inprogress-btn'}>
                <div className={'confirm-payment-button'} onClick={toggleAWB}>
                  {isSelectScheduled(data.sale[0]) ? <p>Schedule a Pick-up</p> : <p>Select delivery method</p>}
                  {/* <IconContext.Provider value={{ color: '#fff', size: '20px' }}>
                    <div>
                      <BsArrowRight />
                    </div>
                  </IconContext.Provider> */}
                </div>
              </div>
            )}
          </div>

          <div className={'close-button'} onClick={onToggle}>
            <IconContext.Provider value={{ color: '#242424', size: '12px' }}>
              <div>
                <GrClose />
              </div>
            </IconContext.Provider>
          </div>
        </>
      </Modal>
    );
  }
  // Not rendering the modal component is data is unavailable to prevent undefined error
  return <div />;
}

const mapStateToProps = (state: stateToProps) => {
  return {};
};

const mapDispatchToProps = (dispatch: (arg0: any) => any) => {
  return {
    doAcceptOffer: (query: number, payload: PayloadAcceptOffer) =>
      dispatch(doAcceptOfferRequest(query, payload)),
    doDeleteListing: (idSale: number, status: PayloadDeleteListing) =>
      dispatch(handleSuspended(idSale, status)),
    doChangePrice: (idSale: number, body: PayloadChangePrice) =>
      dispatch(handleSuspended(idSale, body)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalInProgressSellingComponent);
